import { auction } from "../redux/config/urlConfig";
import axios from "axios";

async function registerSW() {
  console.log("registerSW");
  if ("serviceWorker" in navigator) {
    try {
      let url = process.env.PUBLIC_URL + "/sw.js";
      const reg = await navigator.serviceWorker.register(url, { scope: "/" });
      console.log("Service worker registered:", reg);

      // Request notification permission
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        throw new Error("Permission not granted for Notification");
      }
      return reg;
    } catch (error) {
      console.log("Service Worker registration failed:", error);
      throw new Error("Service Worker is not supported in this browser");
    }
  }
}

async function subscribe(serviceWorkerReg) {
  let subscription = await serviceWorkerReg.pushManager.getSubscription();
  if (subscription === null) {
    subscription = await serviceWorkerReg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey:
        "BIp-Si8zu-5IkYffp2c6of8-3B5E432m5XDnF237jCZ7JlmCdTLI81hxT6V1Yj8jhTXTGY_sT3RyDKOekwb6ZZQ"
    });
  }

  try {
    const res = await auction.put(
      "/profile/update/update-webpush-token",
      subscription
    );
    localStorage.removeItem("callRegisterAndSubscribe");
    console.log("Subscribed to push notifications", res);
  } catch (error) {
    console.log("error" + error);
  }
}

export { registerSW, subscribe };
